// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("./assets/fonts/Briar/Briar/BriarDisplay.woff", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("./assets/fonts/sawton-complete-desktop/Sawton Complete Desktop/SawtonBauhaus-Bold.otf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_2___ = new URL("./assets/fonts/sawton-complete-desktop/Sawton Complete Desktop/SawtonBauhaus-Light.otf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_3___ = new URL("./assets/fonts/sawton-complete-desktop/Sawton Complete Desktop/SawtonBauhaus-Medium.otf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_4___ = new URL("./assets/fonts/sawton-complete-desktop/Sawton Complete Desktop/SawtonBauhaus-Regular.otf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_5___ = new URL("./assets/fonts/sawton-complete-desktop/Sawton Complete Desktop/SawtonBauhaus-Thin.otf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_6___ = new URL("./assets/fonts/sawton-complete-desktop/Sawton Complete Desktop/SawtonCircular-Bold.otf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_7___ = new URL("./assets/fonts/sawton-complete-desktop/Sawton Complete Desktop/SawtonCircular-Light.otf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_8___ = new URL("./assets/fonts/sawton-complete-desktop/Sawton Complete Desktop/SawtonCircular-Medium.otf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_9___ = new URL("./assets/fonts/sawton-complete-desktop/Sawton Complete Desktop/SawtonCircular-Regular.otf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_10___ = new URL("./assets/fonts/sawton-complete-desktop/Sawton Complete Desktop/SawtonCircular-Thin.otf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_11___ = new URL("./assets/fonts/sawton-complete-desktop/Sawton Complete Desktop/SawtonIndustrial-Bold.otf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_12___ = new URL("./assets/fonts/sawton-complete-desktop/Sawton Complete Desktop/SawtonIndustrial-Light.otf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_13___ = new URL("./assets/fonts/sawton-complete-desktop/Sawton Complete Desktop/SawtonIndustrial-Medium.otf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_14___ = new URL("./assets/fonts/sawton-complete-desktop/Sawton Complete Desktop/SawtonIndustrial-Regular.otf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_15___ = new URL("./assets/fonts/sawton-complete-desktop/Sawton Complete Desktop/SawtonIndustrial-Thin.otf", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Cormorant+Upright:wght@300;400;500;600;700&family=Open+Sans:wght@300;400;500;600;700&display=swap);"]);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
var ___CSS_LOADER_URL_REPLACEMENT_2___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_2___);
var ___CSS_LOADER_URL_REPLACEMENT_3___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_3___);
var ___CSS_LOADER_URL_REPLACEMENT_4___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_4___);
var ___CSS_LOADER_URL_REPLACEMENT_5___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_5___);
var ___CSS_LOADER_URL_REPLACEMENT_6___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_6___);
var ___CSS_LOADER_URL_REPLACEMENT_7___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_7___);
var ___CSS_LOADER_URL_REPLACEMENT_8___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_8___);
var ___CSS_LOADER_URL_REPLACEMENT_9___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_9___);
var ___CSS_LOADER_URL_REPLACEMENT_10___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_10___);
var ___CSS_LOADER_URL_REPLACEMENT_11___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_11___);
var ___CSS_LOADER_URL_REPLACEMENT_12___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_12___);
var ___CSS_LOADER_URL_REPLACEMENT_13___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_13___);
var ___CSS_LOADER_URL_REPLACEMENT_14___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_14___);
var ___CSS_LOADER_URL_REPLACEMENT_15___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_15___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@font-face {
  font-family: "Briar";
  src: url(${___CSS_LOADER_URL_REPLACEMENT_0___}) format("truetype");
  font-weight: normal;
  font-style: normal;
}

@font-face {
  font-family: "SawtonBauhaus-Bold";
  src: url(${___CSS_LOADER_URL_REPLACEMENT_1___})
    format("opentype");
  font-weight: normal;
  font-style: normal;
}

@font-face {
  font-family: "SawtonBauhaus-Light";
  src: url(${___CSS_LOADER_URL_REPLACEMENT_2___})
    format("opentype");
  font-weight: normal;
  font-style: normal;
}

@font-face {
  font-family: "SawtonBauhaus-Medium";
  src: url(${___CSS_LOADER_URL_REPLACEMENT_3___})
    format("opentype");
  font-weight: normal;
  font-style: normal;
}

@font-face {
  font-family: "SawtonBauhaus-Regular";
  src: url(${___CSS_LOADER_URL_REPLACEMENT_4___})
    format("opentype");
  font-weight: normal;
  font-style: normal;
}

@font-face {
  font-family: "SawtonBauhaus-Thin";
  src: url(${___CSS_LOADER_URL_REPLACEMENT_5___})
    format("opentype");
  font-weight: normal;
  font-style: normal;
}

@font-face {
  font-family: "SawtonCircular-Bold";
  src: url(${___CSS_LOADER_URL_REPLACEMENT_6___})
    format("opentype");
  font-weight: normal;
  font-style: normal;
}

@font-face {
  font-family: "SawtonCircular-Light";
  src: url(${___CSS_LOADER_URL_REPLACEMENT_7___})
    format("opentype");
  font-weight: normal;
  font-style: normal;
}

@font-face {
  font-family: "SawtonCircular-Medium";
  src: url(${___CSS_LOADER_URL_REPLACEMENT_8___})
    format("opentype");
  font-weight: normal;
  font-style: normal;
}

@font-face {
  font-family: "SawtonCircular-Regular";
  src: url(${___CSS_LOADER_URL_REPLACEMENT_9___})
    format("opentype");
  font-weight: normal;
  font-style: normal;
}

@font-face {
  font-family: "SawtonCircular-Thin";
  src: url(${___CSS_LOADER_URL_REPLACEMENT_10___})
    format("opentype");
  font-weight: normal;
  font-style: normal;
}

@font-face {
  font-family: "SawtonIndustrial-Bold";
  src: url(${___CSS_LOADER_URL_REPLACEMENT_11___})
    format("opentype");
  font-weight: normal;
  font-style: normal;
}

@font-face {
  font-family: "SawtonIndustrial-Light";
  src: url(${___CSS_LOADER_URL_REPLACEMENT_12___})
    format("opentype");
  font-weight: normal;
  font-style: normal;
}

@font-face {
  font-family: "SawtonIndustrial-Medium";
  src: url(${___CSS_LOADER_URL_REPLACEMENT_13___})
    format("opentype");
  font-weight: normal;
  font-style: normal;
}

@font-face {
  font-family: "SawtonIndustrial-Regular";
  src: url(${___CSS_LOADER_URL_REPLACEMENT_14___})
    format("opentype");
  font-weight: normal;
  font-style: normal;
}

@font-face {
  font-family: "SawtonIndustrial-Thin";
  src: url(${___CSS_LOADER_URL_REPLACEMENT_15___})
    format("opentype");
  font-weight: normal;
  font-style: normal;
}

:root {
  --font-base: "Cormorant Upright", serif;
  --font-alt: "Open Sans", sans-serif;

  --color-blue: #003f64;
  --color-dark-blue: #1a2733;
  --color-creme: #fef4e2;
  --color-marone: #d8a87d;
  --color-little-extra: #3d40e3;
  --color-white: #ffffff;
}

* {
  box-sizing: border-box;
  padding: 0;
  margin: 0;
  scroll-behavior: smooth;
}

a {
  color: unset;
  text-decoration: none;
}

.slide-bottom {
  animation: slide-bottom 0.5s cubic-bezier(0.25, 0.46, 0.45, 0.94) both;
}

@keyframes slide-bottom {
  0% {
    transform: translateY(-25%);
  }
  100% {
    transform: translateY(0);
  }
}
`, "",{"version":3,"sources":["webpack://./src/index.css"],"names":[],"mappings":"AAEA;EACE,oBAAoB;EACpB,+DAA2E;EAC3E,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,iCAAiC;EACjC;sBACoB;EACpB,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,kCAAkC;EAClC;sBACoB;EACpB,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,mCAAmC;EACnC;sBACoB;EACpB,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,oCAAoC;EACpC;sBACoB;EACpB,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,iCAAiC;EACjC;sBACoB;EACpB,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,kCAAkC;EAClC;sBACoB;EACpB,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,mCAAmC;EACnC;sBACoB;EACpB,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,oCAAoC;EACpC;sBACoB;EACpB,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,qCAAqC;EACrC;sBACoB;EACpB,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,kCAAkC;EAClC;sBACoB;EACpB,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,oCAAoC;EACpC;sBACoB;EACpB,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,qCAAqC;EACrC;sBACoB;EACpB,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,sCAAsC;EACtC;sBACoB;EACpB,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,uCAAuC;EACvC;sBACoB;EACpB,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,oCAAoC;EACpC;sBACoB;EACpB,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,uCAAuC;EACvC,mCAAmC;;EAEnC,qBAAqB;EACrB,0BAA0B;EAC1B,sBAAsB;EACtB,uBAAuB;EACvB,6BAA6B;EAC7B,sBAAsB;AACxB;;AAEA;EACE,sBAAsB;EACtB,UAAU;EACV,SAAS;EACT,uBAAuB;AACzB;;AAEA;EACE,YAAY;EACZ,qBAAqB;AACvB;;AAEA;EAEE,sEAAsE;AACxE;;AAaA;EACE;IAEE,2BAA2B;EAC7B;EACA;IAEE,wBAAwB;EAC1B;AACF","sourcesContent":["@import url(\"https://fonts.googleapis.com/css2?family=Cormorant+Upright:wght@300;400;500;600;700&family=Open+Sans:wght@300;400;500;600;700&display=swap\");\r\n\r\n@font-face {\r\n  font-family: \"Briar\";\r\n  src: url(\"./assets/fonts/Briar/Briar/BriarDisplay.woff\") format(\"truetype\");\r\n  font-weight: normal;\r\n  font-style: normal;\r\n}\r\n\r\n@font-face {\r\n  font-family: \"SawtonBauhaus-Bold\";\r\n  src: url(\"./assets/fonts/sawton-complete-desktop/Sawton Complete Desktop/SawtonBauhaus-Bold.otf\")\r\n    format(\"opentype\");\r\n  font-weight: normal;\r\n  font-style: normal;\r\n}\r\n\r\n@font-face {\r\n  font-family: \"SawtonBauhaus-Light\";\r\n  src: url(\"./assets/fonts/sawton-complete-desktop/Sawton Complete Desktop/SawtonBauhaus-Light.otf\")\r\n    format(\"opentype\");\r\n  font-weight: normal;\r\n  font-style: normal;\r\n}\r\n\r\n@font-face {\r\n  font-family: \"SawtonBauhaus-Medium\";\r\n  src: url(\"./assets/fonts/sawton-complete-desktop/Sawton Complete Desktop/SawtonBauhaus-Medium.otf\")\r\n    format(\"opentype\");\r\n  font-weight: normal;\r\n  font-style: normal;\r\n}\r\n\r\n@font-face {\r\n  font-family: \"SawtonBauhaus-Regular\";\r\n  src: url(\"./assets/fonts/sawton-complete-desktop/Sawton Complete Desktop/SawtonBauhaus-Regular.otf\")\r\n    format(\"opentype\");\r\n  font-weight: normal;\r\n  font-style: normal;\r\n}\r\n\r\n@font-face {\r\n  font-family: \"SawtonBauhaus-Thin\";\r\n  src: url(\"./assets/fonts/sawton-complete-desktop/Sawton Complete Desktop/SawtonBauhaus-Thin.otf\")\r\n    format(\"opentype\");\r\n  font-weight: normal;\r\n  font-style: normal;\r\n}\r\n\r\n@font-face {\r\n  font-family: \"SawtonCircular-Bold\";\r\n  src: url(\"./assets/fonts/sawton-complete-desktop/Sawton Complete Desktop/SawtonCircular-Bold.otf\")\r\n    format(\"opentype\");\r\n  font-weight: normal;\r\n  font-style: normal;\r\n}\r\n\r\n@font-face {\r\n  font-family: \"SawtonCircular-Light\";\r\n  src: url(\"./assets/fonts/sawton-complete-desktop/Sawton Complete Desktop/SawtonCircular-Light.otf\")\r\n    format(\"opentype\");\r\n  font-weight: normal;\r\n  font-style: normal;\r\n}\r\n\r\n@font-face {\r\n  font-family: \"SawtonCircular-Medium\";\r\n  src: url(\"./assets/fonts/sawton-complete-desktop/Sawton Complete Desktop/SawtonCircular-Medium.otf\")\r\n    format(\"opentype\");\r\n  font-weight: normal;\r\n  font-style: normal;\r\n}\r\n\r\n@font-face {\r\n  font-family: \"SawtonCircular-Regular\";\r\n  src: url(\"./assets/fonts/sawton-complete-desktop/Sawton Complete Desktop/SawtonCircular-Regular.otf\")\r\n    format(\"opentype\");\r\n  font-weight: normal;\r\n  font-style: normal;\r\n}\r\n\r\n@font-face {\r\n  font-family: \"SawtonCircular-Thin\";\r\n  src: url(\"./assets/fonts/sawton-complete-desktop/Sawton Complete Desktop/SawtonCircular-Thin.otf\")\r\n    format(\"opentype\");\r\n  font-weight: normal;\r\n  font-style: normal;\r\n}\r\n\r\n@font-face {\r\n  font-family: \"SawtonIndustrial-Bold\";\r\n  src: url(\"./assets/fonts/sawton-complete-desktop/Sawton Complete Desktop/SawtonIndustrial-Bold.otf\")\r\n    format(\"opentype\");\r\n  font-weight: normal;\r\n  font-style: normal;\r\n}\r\n\r\n@font-face {\r\n  font-family: \"SawtonIndustrial-Light\";\r\n  src: url(\"./assets/fonts/sawton-complete-desktop/Sawton Complete Desktop/SawtonIndustrial-Light.otf\")\r\n    format(\"opentype\");\r\n  font-weight: normal;\r\n  font-style: normal;\r\n}\r\n\r\n@font-face {\r\n  font-family: \"SawtonIndustrial-Medium\";\r\n  src: url(\"./assets/fonts/sawton-complete-desktop/Sawton Complete Desktop/SawtonIndustrial-Medium.otf\")\r\n    format(\"opentype\");\r\n  font-weight: normal;\r\n  font-style: normal;\r\n}\r\n\r\n@font-face {\r\n  font-family: \"SawtonIndustrial-Regular\";\r\n  src: url(\"./assets/fonts/sawton-complete-desktop/Sawton Complete Desktop/SawtonIndustrial-Regular.otf\")\r\n    format(\"opentype\");\r\n  font-weight: normal;\r\n  font-style: normal;\r\n}\r\n\r\n@font-face {\r\n  font-family: \"SawtonIndustrial-Thin\";\r\n  src: url(\"./assets/fonts/sawton-complete-desktop/Sawton Complete Desktop/SawtonIndustrial-Thin.otf\")\r\n    format(\"opentype\");\r\n  font-weight: normal;\r\n  font-style: normal;\r\n}\r\n\r\n:root {\r\n  --font-base: \"Cormorant Upright\", serif;\r\n  --font-alt: \"Open Sans\", sans-serif;\r\n\r\n  --color-blue: #003f64;\r\n  --color-dark-blue: #1a2733;\r\n  --color-creme: #fef4e2;\r\n  --color-marone: #d8a87d;\r\n  --color-little-extra: #3d40e3;\r\n  --color-white: #ffffff;\r\n}\r\n\r\n* {\r\n  box-sizing: border-box;\r\n  padding: 0;\r\n  margin: 0;\r\n  scroll-behavior: smooth;\r\n}\r\n\r\na {\r\n  color: unset;\r\n  text-decoration: none;\r\n}\r\n\r\n.slide-bottom {\r\n  -webkit-animation: slide-bottom 0.5s cubic-bezier(0.25, 0.46, 0.45, 0.94) both;\r\n  animation: slide-bottom 0.5s cubic-bezier(0.25, 0.46, 0.45, 0.94) both;\r\n}\r\n\r\n@-webkit-keyframes slide-bottom {\r\n  0% {\r\n    -webkit-transform: translateY(-25%);\r\n    transform: translateY(-25%);\r\n  }\r\n  100% {\r\n    -webkit-transform: translateY(0);\r\n    transform: translateY(0);\r\n  }\r\n}\r\n\r\n@keyframes slide-bottom {\r\n  0% {\r\n    -webkit-transform: translateY(-25%);\r\n    transform: translateY(-25%);\r\n  }\r\n  100% {\r\n    -webkit-transform: translateY(0);\r\n    transform: translateY(0);\r\n  }\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
